import { Map } from "leaflet";
import { create } from "zustand";

const useMapMode = create<MapModeStoreStateType>()((set) => ({
  mode: (localStorage.getItem("mapMode") as MapMode) ?? "LINES",
  setMode: (mode: MapMode) => {
    localStorage.setItem("mapMode", mode);
    set({ mode });
  },
  map: null,
  setMap: (value: Map) => {
    set({ map: value });
  },

  isMapDragging: false,
  setIsMapDragging: (isMapDragging: boolean) => {
    set({ isMapDragging });
  },
}));

export default useMapMode;
